import classNames from 'classnames/bind';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './form.module.scss';

const classesContext = classNames.bind(styles);

export default function LayoutForm({
  className,
  children,
  ...restProps
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element {
  return (
    <div
      className={classesContext(['form', className])}
      {...restProps}>
      {children}
    </div>
  );
}
